// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3MY83","summary":"CartItem_summary__xPm89","price":"CartItem_price__29Nnm","amount":"CartItem_amount__30Txm","actions":"CartItem_actions__2E3m3"};